import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/Dialog';
import { Button } from '@/components/ui/Button';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'default' | 'destructive';
  icon?: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  description,
  confirmText = '확인',
  cancelText = '취소',
  variant = 'default',
  icon,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-[425px]" onClose={onCancel}>
        <DialogHeader>
          <DialogTitle className={icon ? "flex items-center gap-2" : ""}>
            {icon}
            {title}
          </DialogTitle>
          <DialogDescription className={icon ? "whitespace-pre-line text-base mt-2" : ""}>
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button variant={variant} onClick={onConfirm}>
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;

